import { render, staticRenderFns } from "./EPP.vue?vue&type=template&id=89d902f2"
import script from "./EPP.vue?vue&type=script&lang=js"
export * from "./EPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports